export const styles = () => {
  return {
    inputAdornmentContainerIcon: {
      position: 'absolute',
      right: '10px',
    },
  };
};
